import _slicedToArray from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["className", "tabIndex", "focused", "open", "dropUp", "disabled", "readOnly", "autofilling"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import cn from 'classnames';
import React, { useState } from 'react';
import useGlobalListener from '@restart/hooks/useGlobalListener';
function useKeyboardNavigationCheck() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNavigatingViaKeyboard = _useState2[0],
    setIsNavigatingViaKeyboard = _useState2[1];
  useGlobalListener('keydown', function (_ref2) {
    var key = _ref2.key;
    if (key == ' ' || key === 'Tab' || key == 'Enter' || key && key.indexOf('Arrow') !== -1) {
      setIsNavigatingViaKeyboard(true);
    }
  }); // TODO: use pointerdown

  useGlobalListener('mousedown', function () {
    setIsNavigatingViaKeyboard(false);
  });
  return isNavigatingViaKeyboard;
}
export function useWidgetProps(props) {
  var tabIndex = props.tabIndex != null ? props.tabIndex : -1;
  var isKeyboardNavigating = useKeyboardNavigationCheck();
  return {
    tabIndex: tabIndex,
    'data-intent': isKeyboardNavigating ? 'keyboard' : 'mouse',
    className: cn(props.className, 'rw-widget', props.disabled && 'rw-state-disabled', props.readOnly && 'rw-state-readonly', props.focused && 'rw-state-focus', props.autofilling && 'rw-webkit-autofill', props.open && "rw-open".concat(props.dropUp ? '-up' : ''))
  };
}
var Widget = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    tabIndex = _ref.tabIndex,
    focused = _ref.focused,
    open = _ref.open,
    dropUp = _ref.dropUp,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    autofilling = _ref.autofilling,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var widgetProps = useWidgetProps({
    className: className,
    tabIndex: tabIndex,
    focused: focused,
    open: open,
    dropUp: dropUp,
    disabled: disabled,
    readOnly: readOnly,
    autofilling: autofilling
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props, widgetProps));
});
Widget.displayName = 'Widget';
export default Widget;